import { MuiThemeProivider } from "styles/mui-config";
import { ToastContainer } from "react-toastify";
import { HashRouter } from "react-router-dom";
import RTL from "styles/rtl-config";

import Routes from "routes";
import { StyledContainer } from "components/shared/Container";
import ScrollToTop from "components/shared/ScrollToTop";
import ContextProviders from "store";

function App() {
  return (
    <ContextProviders>
      <HashRouter>
        <MuiThemeProivider>
          <RTL>
            <ScrollToTop>
              <StyledContainer dir="rtl">
                <ToastContainer rtl/>
                <Routes />
              </StyledContainer>
            </ScrollToTop>
          </RTL>
        </MuiThemeProivider>
      </HashRouter>
    </ContextProviders>
  );
}

export default App;
